import * as React from 'react';

export const AppLogo = () => {
  return (
    <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="23.5" cy="23.5" r="22" fill="#00BED4" />
      <circle cx="23.5" cy="23.5" r="22" fill="url(#paint0_linear_315_29380)" />
      <circle cx="23.5" cy="23.5" r="22" stroke="white" strokeWidth="3" />
      <g clipPath="url(#clip0_315_29380)">
        <path
          d="M15.714 14.6525C14.1993 15.3127 13.148 17.1437 13.1107 19.6649C13.1081 19.8843 13.1861 20.097 13.3299 20.2627C13.8421 20.8929 14.5122 21.3761 15.2718 21.6632C16.0315 21.9503 16.8537 22.0309 17.6546 21.897C19.1195 21.6678 20.3751 20.4396 21.252 19.2962C21.5952 18.7964 21.8747 18.2558 22.084 17.6868C22.1343 17.5461 22.1503 17.3954 22.1308 17.2473C22.1114 17.0991 22.0569 16.9578 21.9719 16.8348C20.3626 14.528 18.0806 13.6286 15.714 14.6525Z"
          fill="url(#paint1_linear_315_29380)"
        />
        <path
          d="M32.6069 15.7736C31.6181 14.8162 30.2962 14.2803 28.9199 14.2788C28.2334 14.2701 27.5532 14.4103 26.9261 14.6899C26.299 14.9695 25.7401 15.3817 25.2877 15.8981C24.5852 16.7128 23.8851 17.5872 23.2125 18.474C23.1926 18.5139 21.3391 21.3116 19.3262 22.2806C18.8501 22.5464 18.3318 22.7284 17.7941 22.8187C17.4875 22.8666 17.1777 22.8907 16.8674 22.891C15.6968 22.8911 14.5587 22.5059 13.6288 21.7948C13.5986 21.7728 13.5625 21.7604 13.5252 21.7591C13.4879 21.7577 13.451 21.7676 13.4194 21.7875C13.3877 21.8073 13.3628 21.8362 13.3477 21.8704C13.3326 21.9045 13.3281 21.9425 13.3348 21.9792C13.7176 23.7283 14.3913 25.4007 15.3278 26.9268C18.9102 32.963 22.941 32.679 22.941 32.679H23.1054C24.0471 32.679 28.8701 32.2854 33.3393 25.016C35.4494 21.5856 34.58 17.6918 32.6069 15.7736Z"
          fill="url(#paint2_linear_315_29380)"
        />
      </g>
      <defs>
        <linearGradient id="paint0_linear_315_29380" x1="33.34" y1="39.695" x2="15.3" y2="6.485" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" stopOpacity="0.5" />
        </linearGradient>
        <linearGradient id="paint1_linear_315_29380" x1="12.2063" y1="15.1831" x2="22.9535" y2="21.3888" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" />
          <stop offset="0.06" stopColor="white" />
          <stop offset="0.21" stopColor="white" stopOpacity="0.96" />
          <stop offset="0.46" stopColor="white" stopOpacity="0.87" />
          <stop offset="0.77" stopColor="white" stopOpacity="0.72" />
          <stop offset="0.8" stopColor="white" stopOpacity="0.7" />
          <stop offset="1" stopColor="white" stopOpacity="0.4" />
        </linearGradient>
        <linearGradient id="paint2_linear_315_29380" x1="29.9618" y1="11.9283" x2="16.5614" y2="35.138" gradientUnits="userSpaceOnUse">
          <stop stopColor="#F5426E" />
          <stop offset="0.3" stopColor="#F5426E" />
          <stop offset="0.39" stopColor="#F64772" />
          <stop offset="0.51" stopColor="#F7577F" />
          <stop offset="0.64" stopColor="#FA7195" />
          <stop offset="0.78" stopColor="#FE94B2" />
          <stop offset="0.8" stopColor="#FF9BB8" />
          <stop offset="1" stopColor="#FF9BB8" />
        </linearGradient>
        <clipPath id="clip0_315_29380">
          <rect width="21.4519" height="18.45" fill="white" transform="translate(13.1106 14.2316)" />
        </clipPath>
      </defs>
    </svg>
  );
};
